import { ColorTokens, GetProps, ThemeName } from '@mythical/ui'

import { PlanLevel } from 'app/constants/tiers'

import { Tag } from '../../Tag/Tag'

export interface TierTheme {
  bg: ColorTokens
  buttonTheme: ThemeName
  tagTheme: GetProps<typeof Tag>['variant']
  textColor: ColorTokens
  toggleTheme: ThemeName
  toggleBorderColor: ColorTokens
  toggleInactiveColor: ColorTokens
}

const DarkTheme: TierTheme = {
  bg: '$bgTertiary_op80',
  buttonTheme: 'pink',
  toggleTheme: 'pink',
  tagTheme: 'mustard',
  textColor: '$brandPink',
  toggleBorderColor: '$brandPink',
  toggleInactiveColor: '$brandPink',
}

const PinkTheme: TierTheme = {
  bg: '$brandPink',
  buttonTheme: 'primary',
  toggleTheme: 'bgPrimary',
  tagTheme: 'primary',
  textColor: '$fgInverted',
  toggleBorderColor: '$bgPrimary',
  toggleInactiveColor: '$bgPrimary',
}

export const TIER_THEME_MAP: Record<PlanLevel, TierTheme> = {
  1: DarkTheme,
  2: PinkTheme,
}
